import { render } from "./Favorite.vue?vue&type=template&id=0b9b5a46"
import script from "./Favorite.vue?vue&type=script&lang=js"
export * from "./Favorite.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/Imanyat-Egypt-Systech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__